if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
      }
      openTab(e) {
        this.querySelectorAll(".tabcontent").forEach((item)=>{
          item.style.display = 'none';
        });
        this.querySelectorAll('.tablinks').forEach((item)=>{
          item.classList.remove('active');
        });

        // Show the current tab, and add an "active" class to the button that opened the tab
        const id = e.currentTarget.getAttribute('data-id');
        this.querySelector('#'+id).style.display = "block";
        e.currentTarget.classList.add('active');

      }
      connectedCallback() {
        this.querySelectorAll('.tablinks').forEach((item)=>item.addEventListener('click',this.openTab.bind(this)));
      }

      disconnectedCallback() {
        this.querySelectorAll('.tablinks').forEach((item)=>item.removeEventListener('click',this.openTab.bind(this)));
      }
    }
  );
}